import { slotsData, providerRankingOrder, providers, platformLinks } from "../data/mockData";

// Pretty label for platform keys like "SGJOGO" -> "SG JOGO"
export function platformLabel(key) {
  if (!key) return key;
  return key.replace(/JOGO$/i, " JOGO");
}

const PLATFORM_COLORS = {
  SGJOGO: "#22c55e", XGJOGO: "#38bdf8", VGJOGO: "#a855f7", HGJOGO: "#06b6d4",
  EGJOGO: "#f97316", FGJOGO: "#ec4899", MGJOGO: "#14b8a6", WGJOGO: "#3b82f6",
  AGJOGO: "#ef4444", BGJOGO: "#6366f1", YGJOGO: "#eab308", DGJOGO: "#a855f7",
};

export const PLATFORMS = Object.keys(platformLinks).map((key) => ({
  id: key,
  label: platformLabel(key),
  link: platformLinks[key],
  color: PLATFORM_COLORS[key] || "#8b5cf6",
}));

export const PROVIDERS = providerRankingOrder.map((p) => ({
  id: p.id,
  name: p.name,
  rank: p.rank,
  gamesCount: (slotsData[p.id] || []).length,
}));

export const PROVIDER_NAMES = providers;

// Flatten the full catalog (single source of truth = mockData)
export const ALL_GAMES = (() => {
  const out = [];
  for (const prov of providerRankingOrder) {
    const list = slotsData[prov.id] || [];
    for (const g of list) {
      out.push({
        id: String(g.id),
        name: g.name,
        image: g.image,
        provider: prov.id,
        providerName: prov.name,
      });
    }
  }
  return out;
})();

export const GAME_BY_ID = ALL_GAMES.reduce((acc, g) => {
  acc[g.id] = g;
  return acc;
}, {});

export const TOTAL_GAMES = ALL_GAMES.length;
export const TOTAL_PLATFORMS = PLATFORMS.length;
export const TOTAL_PROVIDERS = PROVIDERS.filter((p) => p.gamesCount > 0).length;

export const EVENT_TYPE_OPTIONS = [
  { value: "", label: "Todos os eventos" },
  { value: "site_access", label: "Acesso ao site" },
  { value: "platform_select", label: "Seleção de plataforma" },
  { value: "provider_select", label: "Seleção de provedor" },
  { value: "game_open", label: "Abertura de jogo" },
  { value: "signal_view", label: "Visualização de sinal" },
  { value: "platform_exit_click", label: "Clique de saída (plataforma)" },
  { value: "whatsapp_click", label: "Clique WhatsApp" },
  { value: "telegram_click", label: "Clique Telegram" },
  { value: "game_name_copy", label: "Cópia do nome do jogo" },
];

export const EVENT_TYPE_LABELS = EVENT_TYPE_OPTIONS.reduce((a, o) => {
  if (o.value) a[o.value] = o.label;
  return a;
}, {});

export const DEVICE_OPTIONS = [
  { value: "", label: "Todos dispositivos" },
  { value: "desktop", label: "Desktop" },
  { value: "mobile", label: "Mobile" },
  { value: "tablet", label: "Tablet" },
];
